// See EventsErrorAlert.spec.md for EEA-FR-001

import Alert from 'core/components/Alert'
import SimpleLink from 'core/components/SimpleLink'
import Text from 'core/elements/Text'

// Messages shared by the notification bar's drawer and the Notification Center page
export const EVENTS_ERROR_MESSAGE = 'Events could not be loaded.'
export const EVENTS_EMPTY_MESSAGE = 'No events found for the selected timeframe.'

interface Props {
  onRetry: () => void
  className?: string
}

// EEA-FR-001: The load error, announced to screen readers, with a "Try again" link
export default function EventsErrorAlert({ onRetry, className }: Props) {
  return (
    <div role="alert" className={className}>
      <Alert variant="error">
        <Text variant="body2">
          {EVENTS_ERROR_MESSAGE}&nbsp;
          <SimpleLink icon="refresh" onClick={onRetry}>
            Try again
          </SimpleLink>
        </Text>
      </Alert>
    </div>
  )
}
